import type { LiteBaustein } from "../../../../../../lib/validation/lite/LiteSchemas";
import type { DisplayRendererProps } from "../../types";
import DatentypReferenceTable from "./DatentypReferenceTable";

export default function DatentypTableDisplay({
	activeNode,
}: DisplayRendererProps<LiteBaustein>): JSX.Element {
	return <DatentypReferenceTable activeNode={activeNode} />;
}
